import React from 'react';

import Button from '@atlaskit/button/default/button';
import { PopupTrigger } from '@atlassian/entry-points/popup-trigger';

import { popupEntryPoint } from '../fixtures/constellation/popup-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function PopupTriggerBasic(): React.JSX.Element {
	return (
		<RelayWrapper>
			<PopupTrigger
				entryPoint={popupEntryPoint}
				role="dialog"
				label="Example popup"
				placement="bottom-start"
				loadingText="Loading popup content"
				loadingCompleteText="Popup content loaded"
				trigger={(triggerProps) => (
					<Button {...triggerProps} appearance="primary" isSelected={triggerProps['aria-expanded']}>
						{triggerProps['aria-expanded'] ? 'Close popup' : 'Open popup'}
					</Button>
				)}
			/>
		</RelayWrapper>
	);
}
